export const FOOTER_VALUE = 10;
export const MODAL_VALUE = 5;
export const NO_SOP_VALUE = 3;
export const BLOCK_VALUE = 2;
